import { AfterViewInit, Component, DoCheck, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IonContent, MenuController, NavController, Platform, PopoverController } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Course } from '../../models/course';
import { Lesson } from '../../models/lesson';
import { MenuPopoverComponent } from '../../components/menu-popover/menu-popover.component';
import { ShowHideColumnsComponent } from './show-hide-columns/show-hide-columns.component';
import { LessonPrefs, PreferencesProvider } from 'src/app/providers/preferences/preferences.provider';
import { TeacherProvider } from 'src/app/providers/teacher/teacher.provider';
import { Teacher } from 'src/app/models/teacher';
import { LessonSong } from 'src/app/models/lesson-song';
import { instanceToInstance, serialize } from 'class-transformer';
import { saveAs } from 'file-saver';
import { Song } from 'src/app/models/song';
import {
  MessagePopoverButton,
  MessagePopoverComponent
} from 'src/app/components/message-popover/message-popover.component';
import { ParentEducationMoment } from 'src/app/models/parent-education-moment';
import { ResourcesProvider } from 'src/app/providers/resources/resources.provider';
import { Resources } from 'src/app/models/resources';
import { Common } from '../../lib/common';
import { AudioProvider } from 'src/app/providers/audio/audio.provider';
import { LessonSongCssService } from './lesson-song-css.service';
import { CssUtilitiesService } from '../../services/css/css-utilities.service'
import { WindowService } from '../../services/window.service'

import { DragulaService } from 'ng2-dragula'
import { v4 as uuid } from 'uuid';
import { Subject, Subscription, map, takeUntil } from 'rxjs'
import * as $ from 'jquery';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
import { environment } from '../../../environments/environment'
import { TeacherStore } from 'src/app/stores/teacher.store';
import { ResourceStore } from 'src/app/stores/resources.store';

import { convertArrayToCSV } from 'convert-array-to-csv';
import { PdfViewPopupComponent } from 'src/app/components/pdf-view-popup/pdf-view-popup.component';
import { DataSyncService } from 'src/app/services/sync.service';


@Component({
  selector: 'app-lesson',
  templateUrl: './lesson.page.html',
  styleUrls: ['./lesson.page.scss']
})
export class LessonPage implements OnInit, AfterViewInit, OnDestroy, DoCheck {
  lessonPrefs: LessonPrefs; // = this.preferencesProvider.getLessonPrefs()
  courseUuid: string; // = this.route.snapshot.paramMap.get('course')
  lessonUuid: string; // = this.route.snapshot.paramMap.get('lesson')
  sourcePage: string; // = this.route.snapshot.paramMap.get('source_page')
  teacher: Teacher = Teacher.defaults();
  resources: Resources = Resources.defaults();

  ngUnsubscribeTeacher = new Subject();
  ngUnsubscribeResources = new Subject();

  get course(): Course {
    return this.teacher.findCourse(this.courseUuid) || Course.defaults()
  }

  get lesson(): Lesson {
    return this.course.findLesson(this.lessonUuid) || Lesson.defaults()
  }

  dragGroupName: string;
  isDataSaving: boolean = false;
  subs = new Subscription();
  @ViewChild(IonContent) private content: IonContent;
  @ViewChild('fixedHeader', {read: ElementRef}) fixedHeader: ElementRef;

  songs: LessonSong[]

  columnNamesMarginLeft: number = 0
  constructor(private route: ActivatedRoute,
              private navCtrl: NavController,
              private location: Location,
              private popoverCtrl: PopoverController,
              private teacherProvider: TeacherProvider,
              private preferencesProvider: PreferencesProvider,
              public audioProvider: AudioProvider,
              private teacherStore: TeacherStore,
              private resourceStore: ResourceStore,
              private menuCtrl: MenuController,
              public lessonSongCssService: LessonSongCssService,
              public cssUtilitiesService: CssUtilitiesService,
              private windowService: WindowService,
              private dragulaService: DragulaService,
              public platform: Platform,
              private dataSyncService: DataSyncService,
              private router: Router
              ) {


    this.teacher = this.teacherProvider.teacher;
    this.teacherStore.state$
        .pipe(takeUntil(this.ngUnsubscribeTeacher))
        .subscribe(() => {
          this.teacher = this.teacherProvider.teacher;
        });

    this.resources = this.resourceStore.getResources();
    this.resourceStore.state$
        .pipe(takeUntil(this.ngUnsubscribeResources))
        .subscribe(() => {
          this.resources = this.resourceStore.getResources();
        })

    if (platform.is('desktop')) {
      this.columnNamesMarginLeft = -15
    }

    this.dragGroupName = uuid() + 'LESSONS'
    const dragula = this.dragulaService.createGroup(this.dragGroupName, {
      moves: function (el, container, handle) {
        if (Common.canDrag(handle)) {
          el.addEventListener('touchmove', event => event.preventDefault())
          return true
        }
        return false
      }
    })

    this.subs.add(dragulaService.drop(this.dragGroupName)
      .subscribe(({name, el, target, source, sibling}) => {
        this.lesson.songs = this.songs
        this.lesson.isDirty = true
        this.lesson.songs.forEach((ls: LessonSong) => ls.isDirty = true);
        this.teacherProvider.updateLesson(this.course, this.lesson);
      })
    )

    this.subs.add(dragulaService.out(this.dragGroupName)
      .subscribe(async ({name, el, container, source}) => {
        const drake = this.dragulaService.find(this.dragGroupName).drake
        if (drake['dragging'] && source.tagName !== 'TBODY') {
          const elemRect = el.getBoundingClientRect()
          const headerRect = this.fixedHeader.nativeElement.getBoundingClientRect()
          const distanceFromTop = elemRect.top - headerRect.height - 10
          this.content.scrollToPoint(0, distanceFromTop, 500)
        }
      })
    )

    this.lessonPrefs = this.preferencesProvider.getLessonPrefs()
    this.courseUuid = this.route.snapshot.paramMap.get('course')
    this.lessonUuid = this.route.snapshot.paramMap.get('lesson')
    this.sourcePage = this.route.snapshot.paramMap.get('source_page')
  }

  scrollUp(event: MouseEvent ) {
    const drake = this.dragulaService.find(this.dragGroupName).drake
    if (drake['dragging']) {
      this.content.scrollToPoint(0, 0, 500)
    }
  }

  scrollDown(event: MouseEvent ) {
    const drake = this.dragulaService.find(this.dragGroupName).drake
    if (drake['dragging']) {
      this.content.scrollToPoint(0, event.clientY, 500)
    }
  }

  fragment: string
  ngOnInit() {
    this.songs = (this.lessonBeingEdited || this.lesson).songs
    this.windowService.width$.subscribe((width: number) => this.lessonSongCssService.calcColumnWidths(width))
    this.route.fragment.subscribe(fragment => this.fragment = fragment)
    // set edit to alwyas true 
    this.lessonSongCssService.isEditing = true;

    this.dataSyncService.isDataSaving
      .pipe(takeUntil(this.ngUnsubscribeTeacher))
      .subscribe((res: boolean) => {
        if (res) {
          this.isDataSaving = true;
          return;
        }
        this.isDataSaving = false;
      });
  }

  ngDoCheck(): void {
    this.songs = (this.lessonBeingEdited || this.lesson).songs
  }


  ngOnDestroy() {
    this.subs.unsubscribe();
    const group = this.dragulaService.find(this.dragGroupName)
    if (group !== undefined) {
      this.dragulaService.destroy(this.dragGroupName);
    }
      this.ngUnsubscribeTeacher.next(true);
      this.ngUnsubscribeTeacher.complete();
      this.ngUnsubscribeResources.next(true);
      this.ngUnsubscribeResources.complete();
  }

  startTouchY: number
  ngAfterViewInit(): void {
    try {
      setTimeout(() => {
        const el = document.querySelector('#' + this.fragment)
        if (el) {
          el.scrollIntoView({behavior: 'smooth', block: 'start'})
        }
      }, 1000)
    } catch (e) {
    }
    $('.songs').on('touchstart', (e) => {
      if (Common.canDrag(e.target)) {
        this.startTouchY = e.touches[0].clientY
      }
    })
    $('.songs').on('touchmove', (e) => {
      if (Common.canDrag(e.target)) {
        const headerRect = this.fixedHeader.nativeElement.getBoundingClientRect()
        if (e.touches[0].clientY < headerRect.height + 50 || e.touches[0].clientY > window.innerHeight - 50) {
          const drake = this.dragulaService.find(this.dragGroupName).drake
          if (drake['dragging']) {
            this.content.scrollByPoint(0, e.touches[0].clientY - this.startTouchY > 0 ? 15 : -15, 30)
          }
        }
      }
    })
  }

  // Editing

  // NOTE: Any actions performed on lessonBeingEdited are done on that object itself. We do
  // not make those changes through the teacherProvider API until we are ready to save
  // the lessonBeingEdited. It is always possible we could cancel the editing session.
  get lessonBeingEdited(): Lesson {
    return this.teacher.lessonsBeingEdited.get(this.lesson.uuid)
  }

  get isEditing(): boolean {
    // we can remove this function from parent and child both component.
    // return !!this.lessonBeingEdited
    return false;
  }

  edit() {
    if (!this.isEditing) {
      this.lessonSongCssService.isEditing = true
      this.teacher.lessonsBeingEdited.set(this.lesson.uuid, instanceToInstance(this.lesson))
      this.teacherProvider.saveTeacher();
    }
  }

  cancel() {
    // this.lessonSongCssService.isEditing = false
    this.teacher.lessonsBeingEdited.delete(this.lesson.uuid)
    this.teacherProvider.saveTeacher();
  }

  save(lessonSong) {
    // Don't show the "Lesson Validation" popover until all slots are full (#757)
    const numberEmptySlots = (this.lessonBeingEdited || this.lesson).songs.reduce((sum: number, song: LessonSong) => sum + (song.name ? 0 : 1), 0)
    if (numberEmptySlots > 0) {
      this.autoSave(lessonSong)
      return
    }

    const unmetRules = this.unmetRules()
    if (unmetRules.length > 0) {
      this.autoSave(lessonSong)
      MessagePopoverComponent.present(this.popoverCtrl, 'Checklist Alert!', 'You need:\n\n' + unmetRules, false, false, [
        // {
        //   name: 'Fix', type: MessagePopoverButton.Type.Cancel, action: () => {
        //   }
        // },
        {
          name: 'Ok', type: MessagePopoverButton.Type.Submit, action: () => {
          }
        }
      ])
    } else {
      this.autoSave(lessonSong)
    }
  }

  // below function is being replaced by auto save function
  private _save() {
    // this.lessonSongCssService.isEditing = false
    this.teacherProvider.updateLesson(this.course, this.lessonBeingEdited)
    this.teacher.lessonsBeingEdited.delete(this.lesson.uuid)
    this.teacherProvider.saveTeacher()
  }

  // Auto Save Functionality
  autoSave(lessonSong) {
    const index = this.lesson.indexOfLessonSong(lessonSong.uuid)
    const updatedLessonSong: any = this.lesson.songs[index]
    if (updatedLessonSong) {
      updatedLessonSong.copyFrom(lessonSong)
      updatedLessonSong.isDirty = true      
    }
    this.teacher.lessonsBeingEdited.delete(this.lesson.uuid)
    this.teacherProvider.updateLesson(this.course, this.lesson)
  }

  // Header
  gotoBowlingPage(course: Course) {
    // resets navigation stack so back will load new copy of page
    this.navCtrl.navigateRoot(`/bowling/${course.uuid}/${this.lesson.uuid}`);
  }

  // TODO: Refactor into reusable code.

  addSongShown: boolean = false
  addSongHandler: (lessonSong: LessonSong) => void

  toggleMenu(type: string){
    const menu = Common.menu('song-details-lesson-page-menu')
    menu.side = 'end'
    if(type == 'open') {
      menu.open('song-details-lesson-page-menu')
    }else{
      menu.close('song-details-lesson-page-menu')
    }
  }


  async addSong(index) {
    this.addSongShown = true
    this.toggleMenu('open')
    this.addSongHandler = (lessonSong: LessonSong) => {
      this.toggleMenu('close')
      if (lessonSong) {
        this.edit()  // #177 automatically switch to edit mode when select a song

        const updatedLessonSong = this.lessonBeingEdited.songs[index]
        updatedLessonSong.copyFrom(lessonSong)
        this.save(updatedLessonSong)
        // this.teacherProvider.saveTeacher()
      }
    }
  }

  presentLessonSelectorPopover(event) {
    MenuPopoverComponent.present(this.popoverCtrl, 'lesson-plans-popover', event,
      this.course.displayableLessons.map((lesson: Lesson) => {
        return {
          name: lesson.name, action: () => {
            this.lessonUuid = lesson.uuid
          }
        }
      }, 240)
    )
  }

  scrollTo(className: string) {
    const elementList = document.querySelectorAll('.' + className);
    const element = elementList[0] as HTMLElement;
    if (element) {
      element.scrollIntoView({behavior: 'smooth'});
    }
  }

  togglePem(lessonSong: LessonSong) {  // is done on lessonBeingEdited
    if (lessonSong.pemUuid) {
      this.showPemInfo(lessonSong)
    } else {
      this.addPem(lessonSong)
    }
  }

  addPemShown: boolean = false
  addPemHandler: (pem: ParentEducationMoment) => void

  async addPem(lessonSong: LessonSong) {  // is done on lessonBeingEdited
    this.addPemShown = true
    this.toggleMenu('open')
    this.edit()
    this.addPemHandler = (pem: ParentEducationMoment) => {
      this.toggleMenu('close')
      if (pem) {
        lessonSong.pemUuid = pem.uuid
        lessonSong.isDirty = true
        this.autoSave(lessonSong);
      }
    }
  }

  pemDetailShown: boolean = false
  pemDetailPem: ParentEducationMoment
  pemDetailLessonSong: LessonSong

  showPemInfo(lessonSong: LessonSong) {
    this.pemDetailPem = this.resources.findPem(lessonSong.pemUuid) || this.teacher.findCustomPem(lessonSong.pemUuid)
    this.pemDetailLessonSong = lessonSong

    this.pemDetailShown = true
    this.toggleMenu('open')
  }

  async donePemDetail() {
    this.toggleMenu('close')
  }

  removePem() {  // is done on lessonBeingEdited
    this.donePemDetail()

    this.edit()  // switch to edit mode so we are working with the lessonBeingEdited

    const lessonSong = this.lessonBeingEdited.findLessonSong(this.pemDetailLessonSong.uuid)
    lessonSong.pemUuid = null
    lessonSong.isDirty = true
    this.autoSave(lessonSong)
    // this.teacherProvider.saveTeacher()
  }

  playRecording(lessonSong: LessonSong) {
    if (this.lessonSongCssService.playingSong === lessonSong) {
      this.lessonSongCssService.playingSong = null;
      this.audioProvider.pause()
    } else if (lessonSong.isCustom) {
      this.lessonSongCssService.playingSong = null
      this.audioProvider.stop()
      Common.openOutsideUrl(lessonSong.url)
    } else if (lessonSong.canPlay) {
      this.lessonSongCssService.playingSong = lessonSong
      this.audioProvider.play((lessonSong.recordingType === LessonSong.RecordingType.Original ? lessonSong.url : lessonSong.karaokeUrl) || 'assets/mp3/01_Hello_Song.mp3')
    }
  }

  recordingType(lessonSong: LessonSong): string {
    if (lessonSong.isCustom) {
      return 'Custom'
    }
    if (lessonSong.recordingType === LessonSong.RecordingType.None) {
      return ''
    }
    if (lessonSong.recordingType === LessonSong.RecordingType.Original) {
      return 'Original'
    }
    if (lessonSong.recordingType === LessonSong.RecordingType.Karaoke) {
      return 'Karaoke'
    }
    return ''
  }

  songDetailShown: boolean = false
  songInfoSong: Song
  songInfoLessonSong: LessonSong

  showSongInfo(lessonSong: LessonSong) {
    if (lessonSong.songUuid) {
      const collection = Song.findCollection(lessonSong.songUuid, this.resources.collections)
      if (!collection) {
        MessagePopoverComponent.present(this.popoverCtrl, 'Song Not Found', 'The information for this song could not be found.');
        return
      }

      this.songInfoSong = collection.findSong(lessonSong.songUuid)
    } else { // for custom songs, just use the lessonSong; won't display other info since there isn't any other info
      this.songInfoSong = lessonSong as any
    }
    this.songInfoLessonSong = lessonSong

    this.songDetailShown = true
    this.toggleMenu('open')
  }

  doneSongDetail() {
    this.toggleMenu('close')
  }

  removeSong() {  // is done on lessonBeingEdited
    MessagePopoverComponent.present(this.popoverCtrl, 'Remove Song?', 'Are you sure you want to remove this song from the lesson plan?', false, false, [
      { name: 'Cancel', type: MessagePopoverButton.Type.Cancel },
      { name: 'Remove', type: MessagePopoverButton.Type.Submit, action: () => {
        this.doneSongDetail()

        this.edit()  // switch to edit mode so we are working with the lessonBeingEdited

        const lessonSong = this.lessonBeingEdited.findLessonSong(this.songInfoLessonSong.uuid)
        lessonSong.copyFrom(LessonSong.defaults())
        lessonSong.isDirty = true;
        this.autoSave(lessonSong)
        this.teacherProvider.saveTeacher()
      }}
    ])
  }

  // Lesson Popover

  presentLessonActionPopover(event) {
    MenuPopoverComponent.present(this.popoverCtrl, 'lesson-plans-popover', event, [
      // {name: 'Export Lesson', icon: 'mt-export', action: () => { this.exportLesson() }},
      {
        name: 'Save as PDF (w/ Detail)', icon: 'mt-print', action: () => {
          this.printLesson()
        }
      },
      {
        name: 'Save as PDF (Simple)', icon: 'mt-print', action: () => {
          this.printLessonSimple()
        }
      },
      {
        name: 'Save as CSV', icon: 'mt-print', action: () => {
          this.printCSVLesson()
        }
      },
      // {name: 'Send Lesson', icon: 'mt-send', action: () => { this.sendLesson() }},
      // {name: 'Show/Hide Columns', icon: 'mt-show', action: () => { this.showHideColumns() }},
      {
        name: 'Delete Lesson', icon: 'mt-trash', action: () => {
          this.deleteLesson()
        }
      },
    ], 320)
  }

  exportLesson() {
    // https://stackoverflow.com/questions/35138424/how-do-i-download-a-file-with-angular2/35210392
    // https://www.npmjs.com/package/file-saver
    const lessonJson = serialize(this.lesson.unsavedCopy())
    const file = new File([lessonJson], 'lesson.mtlesson', {type: 'text/plain;charset=utf-8'})
    saveAs(file);
  }

 async printLesson() {
    const doc = new jsPDF('l');

    doc.addFileToVFS('NotoSans-Regular.ttf', environment.NotoRegular)
    doc.addFont('NotoSans-Regular.ttf', 'NotoSans', 'normal')
    doc.addFileToVFS('NotoSans-Bold.ttf', environment.NotoBold)
    doc.addFont('NotoSans-Bold.ttf', 'NotoSans', 'bold')

    // doc.setFont('Helvetica'); // set font

    doc.setFont('NotoSans')

    const body: any = await this.generateData()
    const checks = {}

    const centeredText = function(s, y) {
      const textWidth = doc.getStringUnitWidth(s) * doc.getFontSize() / doc.internal.scaleFactor;
      const textOffset = (doc.internal.pageSize.width - textWidth) / 2;
      doc.text(s, textOffset, y);
    }
    const title: string = this.getPDFTitle(false);
    centeredText(title, 15)
    centeredText(this.getPDFLessonName(), 25)

    doc.setFontSize(10)

    autoTable(doc, {
      startY: 30,
      theme: 'plain',
      styles: {lineWidth: 0.1},
      headStyles: {valign: 'middle', fillColor: '#f3f3f3'},
      bodyStyles: {valign: 'middle'},
      columnStyles: {
        0: {cellWidth: 10},
        1: {halign: 'left', minCellWidth: 60, fontSize: 9, cellPadding: 2},
        2: {halign: 'left', minCellWidth: 28, fontSize: 9, cellPadding: 2},
        3: {halign: 'left', minCellWidth: 30, fontSize: 9, cellPadding: 2},
        4: {halign: 'center', minCellWidth: 14, fontSize: 9, cellPadding: 2},
        5: {halign: 'left', minCellWidth: 61, fontSize: 9, cellPadding: {top: 2, right: 6, left: 2, bottom: 2}},
        6: {halign: 'center', minCellWidth: 16, fontSize: 9, cellPadding: 2},
        7: {halign: 'center', minCellWidth: 16, fontSize: 9, cellPadding: 2},
        8: {halign: 'left', minCellWidth: 32, fontSize: 9, cellPadding: 2},
      },
      head: [['', 'Song Name', 'Tonality (SP)', 'Meter', 'RP/TP', 'Activity','Inst/\nProp', 'Rec.' ,this.pemName]], 
      body: body,
      foot: [
        [
          {
            content: '* = Song Without Words', 
            colSpan: 9, 
            styles: {
              fontStyle: 'normal',
              lineWidth: 0,
              cellPadding: {
                top: 5,
                right: 0,
                bottom: 0,
                left: 1
              }
            }
          }
        ]
      ],
      willDrawCell: data => {
        doc.setFont('NotoSans');

        // Convert data to checkmarks
        const cellsContainingChecks = [];
        if (data.section === 'body' && cellsContainingChecks.includes(data.column.index)) { 
          if (data.cell.raw === 1 || data.cell.raw) {
            checks[data.row.index + ':' + data.column.index] = true
          }
          data.cell.text = ['']
        }
        if (data.section === 'body') {
          doc.setFont('NotoSans', 'normal')
          if (data.column.index === 2 && this.lesson.songs[data.row.index]?.isNonmajor) {
            doc.setFont('NotoSans', 'bold')
          }
          if (data.column.index === 3 && this.lesson.songs[data.row.index]?.isNonduple) {
            doc.setFont('NotoSans', 'bold')
          }
        }
      },
      didDrawCell: data => {
        if (data.section === 'body') {
          if (checks[data.row.index + ':' + data.column.index]) {
            this.addCheckmark(doc, data)
          }
          if (data.column.index !== 0 && data.column.index !== 10) {
            doc.setLineWidth(0.1)
            doc.line(data.cell.x + data.cell.width, data.cell.y, data.cell.x + data.cell.width, data.cell.y + data.cell.height)
          }

          doc.line(data.cell.x, data.cell.y, data.cell.x + data.cell.width, data.cell.y)

          if (data.row.index === body.length - 1) {
            doc.line(data.cell.x, data.cell.y + data.cell.height, data.cell.x + data.cell.width, data.cell.y + data.cell.height)
          }
        }
      }
    })
    doc.addPage()
    doc.text('Notes', 15, 15)
    doc.setFontSize(9)
    const pageSize = doc.internal.pageSize;
    const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
    const text = doc.splitTextToSize(this.lesson.notes, pageWidth - 35, {});
    doc.text(text, 15, 20)

    this.displayPdf(doc)
  }

  private addCheckmark(doc, data) {
    if (this.platform.is('ios')) { // ios pwa requires post to server which doesn't like the base64 image.
      const color = doc.getDrawColor();
      doc.setDrawColor(0);
      doc.setLineWidth(0.5);
      const midPoint = data.cell.x + data.cell.width / 2;
      // outside circle
      doc.circle(midPoint, data.cell.y + 4, 2);

      // checkmark
      doc.line(midPoint - .25, data.cell.y + 5, midPoint - 1, data.cell.y + 4);
      doc.line(midPoint - .25, data.cell.y + 5, midPoint + 1, data.cell.y + 3.25);

      // cutout notch
      doc.setDrawColor(255, 255, 255);
      doc.setFillColor(255, 255, 255);
      doc.circle(midPoint - 0.75, data.cell.y + 6.25, 0.5, 'FD')

      doc.setDrawColor(color);
    } else {
      const base64Img = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAAAXNSR0IArs4c6QAAAARnQ' +
        'U1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAIjSURBVEhL7ZS/67FRFMD9AxaDMhlNMkiUlGKzWs3ye5DBJpOIgSwyKPkDlMFC' +
        'FDFbiEIoP5IwoPw4b+e4Ht/n6+H99ta7vL2fusNz7r2fe5x7DxH8Rf5x+e12g+12C+v1GjabDVyvVzbzmY9ylMXjcVAoFCASibghkUjA5/P' +
        'BaDRiK4URlGOmjUYDVCoVJ7PZbBCJRCAQCHCHicViyGazcD6f2U4+gvJarQZyuZw2x2Ix2O12bObO6XSCQqHAHRKNRuFyubDZJy9y/Kl6vZ' +
        '7E+Xz+Y30fSchkMqjX6yz6hCfHcmCNMZtgMEgZfgLXZzIZWu9yueB4PLKZOzw5vgir1UqZNJtNFn2l3+/THeRyOZjNZmA0GkGpVEK322Ur7' +
        'vDkg8EA1Go1mEwmWCwWLMpnPB6DxWKhbP1+PyXkdDrp+3tpePJer0cvxGw2w2q1olin04F0Og3z+ZwndjgcsN/vaU04HKZYuVym7we/zTyR' +
        'SNBGjUYDOp3uRYx1/lHmuAFrKZVKodVqcTGU4WYcHo+HEyPT6RQMBgNotVoYDocseocnR7ApUGK32+FwOFAMZaFQiMZX8dfX4na7ufUPXuR' +
        'Y20ddceO77kNxpVKhd46j3W6zmScvcuTRHHhAsVhk0SfYsXgX+LfwqdkE5Qi+kmQyCZPJhL7xpXi9XqovCvFgbP9SqfS2i9/Kv1OtVilTlO' +
        'LlpVIpWC6XbFaYH8v/hP9yAQB+AVsLQQcbfqq9AAAAAElFTkSuQmCC'
      doc.addImage(base64Img, 'PNG', data.cell.x + data.cell.width / 2 - 2.5, data.cell.y + 1, 5, 5);
    }
  }

  printLessonSimple() {
    const capitalizeFirstLetter = (string) => {
      if (string.length === 0) {
        return string;
      }
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const doc = new jsPDF('p');

    doc.addFileToVFS('NotoSans-Regular.ttf', environment.NotoRegular);
    doc.addFont('NotoSans-Regular.ttf', 'NotoSans', 'normal');
    doc.addFileToVFS('NotoSans-Bold.ttf', environment.NotoBold);
    doc.addFont('NotoSans-Bold.ttf', 'NotoSans', 'bold');

    doc.setFont('NotoSans'); // set font

    const body = []
    const checks = {}
    this.lesson.songs.forEach((song: LessonSong, index) => {
      let pemName = ''
      if (song.pemUuid) {
        let pem = this.resources.findPem(song.pemUuid)
        if (!pem) {
          pem = this.teacher.findCustomPem(song.pemUuid)
        }
        if (pem) {
          pemName = pem.name || ''
        }
      }

      // let mediaTypes = []
      // if (song.hasPem) {
      //   mediaTypes.push(this.pemName)
      // }
      // if (song.hasInstrument) {
      //   mediaTypes.push('INST')
      // }
      // if (song.useRecording) {
      //   mediaTypes.push('REC')
      // }

      let patterns = []
      if (song.hasRp) {
        patterns.push('RP')
      }
      if (song.hasTp) {
        patterns.push('TP')
      }

      let songName = song.name.replace('(Teacher Mix)', '(TM)')
      if (song.isSwow) {
        songName += ' *'
      }

      // let musicInfo: string;
      // if(song.meter){
      //   musicInfo =  `${song.formattedTonality} - ${song.meter}`
      // }else{
      //   musicInfo = song.formattedTonality
      // }

      body.push([
        `${(index + 1)}`,
        songName,
        song.formattedTonality,
        song.meter,
        patterns.join(', ').trim(),
        song.hasInstrument ? "INST" : "",
        // song.useRecording ? "REC" : "",
      ])
    })
    const centeredText = function(s, y) {
      const textWidth = doc.getStringUnitWidth(s) * doc.getFontSize() / doc.internal.scaleFactor;
      const textOffset = (doc.internal.pageSize.width - textWidth) / 2;
      doc.text(s, textOffset, y);
    }
    // const title: string = this.getPDFTitle();
    // centeredText(title, 15)

    const title: string = this.getPDFTitle(false);
    centeredText(title, 15)
    centeredText(this.getPDFLessonName(), 25)

    const fontSize: number = 13

    doc.setFontSize(10)
    autoTable(doc, {
      startY: 30,
      theme: 'plain',
      styles: {fontSize, lineWidth: 0.1, valign: 'middle'},
      headStyles: {valign: 'middle', fillColor: '#f3f3f3', fontSize: 10},
      columnStyles: {
        0: {halign: 'center', cellWidth: 10},
        1: {halign: 'left', cellWidth: 86, fontSize},
        2: {halign: 'left', cellWidth: 30, fontSize, fillColor: '#f3f3f3'},
        3: {halign: 'center', cellWidth: 20, fontSize},
        4: {halign: 'center', cellWidth: 15, fontSize, fillColor: '#f3f3f3'},
        5: {halign: 'center', cellWidth: 20, fontSize},
        // 6: {halign: 'center', cellWidth: 21, fontSize, fillColor: '#f3f3f3'},
      },
      head: [['', 'Song Name', 'Tonality (SP)', 'Meter', 'RP/TP', 'Inst/Prop']],
      body: body,
      foot: [
        [
          {
            content: '* = Song Without Words', 
            colSpan: 7, 
            styles: {
              fontStyle: 'normal',
              lineWidth: 0,
              cellPadding: {
                top: 5,
                right: 0,
                bottom: 0,
                left: 1
              }
            }
          }
        ]
      ],
      willDrawCell: data => {
        doc.setFont('NotoSans');

        if (data.section === 'head') {
          doc.setFontSize(10);
          if (data.column.index !== 0 && data.column.index !== 1) {
            doc.setFontSize(10);
          }
        }

        // Convert data to checkmarks
        const cellsContainingChecks = []; // [2, 3];
        if (data.section === 'body' && cellsContainingChecks.includes(data.column.index)) {
          if (data.cell.raw === 1 || data.cell.raw) {
            checks[data.row.index + ':' + data.column.index] = true
          }
          data.cell.text = ['']
        }
        if (data.section === 'body') {
          doc.setFont('NotoSans', 'normal')
          if (data.column.index === 2 && this.lesson.songs[data.row.index]?.isNonmajor) {
            doc.setFont('NotoSans', 'bold')
          }
          if (data.column.index === 3 && this.lesson.songs[data.row.index]?.isNonduple) {
            doc.setFont('NotoSans', 'bold')
          }
        }
      },
      didDrawCell: data => {
        if (data.section === 'body') {
          if (checks[data.row.index + ':' + data.column.index]) {
            this.addCheckmark(doc, data)
          }
          if (data.column.index !== 0 && data.column.index !== 5) {
            doc.setLineWidth(0.1)
            doc.line(data.cell.x + data.cell.width, data.cell.y, data.cell.x + data.cell.width, data.cell.y + data.cell.height)
          }

          doc.line(data.cell.x, data.cell.y, data.cell.x + data.cell.width, data.cell.y)

          if (data.row.index === body.length - 1) {
            doc.line(data.cell.x, data.cell.y + data.cell.height, data.cell.x + data.cell.width, data.cell.y + data.cell.height)
          }
        }
      }
    })

    this.displayPdf(doc)
  }

  generateData(){
    return new Promise(async (resolve, reject) => {
      try{
        const capitalizeFirstLetter = (string) => {
          if (string.length === 0) {
            return string;
          }
          return string.charAt(0).toUpperCase() + string.slice(1);
        }
        const body = []
        this.lesson.songs.forEach((song: LessonSong, index) => {
          let pemName = ''
          if (song.pemUuid) {
            let pem = this.resources.findPem(song.pemUuid)
            if (!pem) {
              pem = this.teacher.findCustomPem(song.pemUuid)
            }
            if (pem) {
              pemName = pem.name || ''
            }
          }

          let songName = song.name.replace('(Teacher Mix)', '(TM)')
          if (song.isSwow) {
            songName += ' *'
          }

          let patterns = []
          if (song.hasRp) {
            patterns.push('RP')
          }
          if (song.hasTp) {
            patterns.push('TP')
          }
          // let musicInfo: string;
          // if(song.meter){
          //   musicInfo =  `${song.formattedTonality} - ${song.meter}`
          // }else{
          //   musicInfo = song.formattedTonality
          // }

          // let mediaTypes = []
          // if (song.hasPem) {
          //   mediaTypes.push(this.pemName)
          // }
          // if (song.hasInstrument) {
          //   mediaTypes.push('INST')
          // }
          // if (song.useRecording) {
          //   mediaTypes.push('REC')
          // }

          body.push(
            [
            index + 1,
            songName,
            song.formattedTonality,
            song.meter.replace('/', '/\n'),
            patterns.join(', ').trim(),
            song.activity,
            song.hasInstrument ? "INST" : "",
            song.useRecording ? "REC" : "",
            pemName,
           ]);

        })
        resolve(body)
      }
      catch (err) {
        reject(err);
      }
    });
  }

  generateDataForCSV(){
    return new Promise(async (resolve, reject) => {
      try{
        const body = []
        this.lesson.songs.forEach((song: LessonSong, index) => {
          let pemName = ''
          if (song.pemUuid) {
            let pem = this.resources.findPem(song.pemUuid)
            if (!pem) {
              pem = this.teacher.findCustomPem(song.pemUuid)
            }
            if (pem) {
              pemName = pem.name || ''
            }
          }

          let songName = song.name.replace('(Teacher Mix)', '(TM)')
          if (song.isSwow) {
            songName += ' *'
          }

          let patterns = []
          if (song.hasRp) {
            patterns.push('RP')
          }
          if (song.hasTp) {
            patterns.push('TP')
          }
          let meter: string;
          if(song.meter){
            meter = song.meter ?  song.meter : ''
          }

          body.push(
            [
            index + 1,
            songName,
            song.formattedTonality,
            meter,
            patterns.join(', ').trim(),
            song.isSwow ? "SWOW" : '',
            song.activity,
            song.hasInstrument ? "INST" : "",
            song.useRecording ? "REC" : "",
            pemName,
           ]);

        })
        resolve(body)
      }
      catch (err) {
        reject(err);
      }
    });
  }

 async printCSVLesson(){
    const body: any = await this.generateDataForCSV()
    const headers: string[] = ['', 'Song Name', 'Tonality (SP)', 'Meter', 'RP/TP', 'SWOW', 'Activity', 'Inst/Prop', 'Recording', this.pemName]
    this.downloadCSVFile(body, headers)
  }

  downloadCSVFile(data: any, headers:string[]) {
    data.unshift(headers);
    const csvFromArrayOfArrays = convertArrayToCSV(data);

    const blob: Blob = new Blob([csvFromArrayOfArrays], {
      type: "text/csv;charset=utf-8"
    });

    saveAs(blob, this.getPDFTitle());

  }

  displayPdf(doc: jsPDF) {







    /* Note: Disabling the ios platform API call, See no issue in directly calling the A */
    if (this.platform.is('ios')) {
      // We have older code where we thought that we had to send the pdf to the server in
      // order to get a valid url. That isn't the case. Turns out we couldn't call
      // window.open() inside of an async method.

      // To see the parameters doc.output accepts, see the jspdf.debug.js file in the node_modules
      // Documentation for how to use the doc: https://github.com/MrRio/jsPDF/blob/master/src/jspdf.js
      const data = { document: doc.output() }
      // this.http.post('/print', data, {observe: 'response'}).subscribe((res: HttpResponse<any>) => {
      // Unfortunately we cannot call window.open() from inside of an async method. So we need
      // to display a window and have them say they want to display it.


      this.popoverCtrl.create({
        component: PdfViewPopupComponent,
        cssClass: 'lesson-plans-popover',
        componentProps:  { document: doc.output() }
      }).then(popover => {
        popover.present().then(() => Common.ensurePopoverOnScreen())
        popover.onDidDismiss().then(results => {

          if (results) {

            doc.save(this.lesson.name + '.pdf');
            
          }

          

          // alert('test')


          // if(results && results.data) {
          //   const url = environment.apiRoot + '/print/' + results.data; //  'url that is returned'
          //   if (!window.open(url)) {
          //     window.location.href = url
          //   }
          // }
        })
      })



    } else {
      doc.save(this.lesson.name + '.pdf');
    }
  }

  sendLesson() {
    const lessonJson = serialize(this.lesson.unsavedCopy())
    window.open('mailto:?subject=Lesson&body=' + lessonJson, '_self')
  }

  deleteLesson() {
    MessagePopoverComponent.present(this.popoverCtrl, 'Are You Sure You Want to Delete This?', 'This action cannot be undone.', false, false, [
      {name: 'Cancel', type: MessagePopoverButton.Type.Cancel},
      {
        name: 'Delete', type: MessagePopoverButton.Type.Submit, action: () => {
          this.teacherProvider.deleteLesson(this.course, this.lesson)
          if (this.course.displayableLessons.length === 0) {
            // this.router.navigateByUrl('lesson-plans');
            // this.location.back()  // want to go back to lesson plans, but what if we came here other way??
          } else {
            this.lessonUuid = this.course.displayableLessons[0].uuid
          }
          this.router.navigateByUrl('lesson-plans');
        }
      }
    ])
  }

  async showHideColumns() {
    const popover = await this.popoverCtrl.create({
      component: ShowHideColumnsComponent,
      cssClass: 'lesson-plans-popover',
      event: null
    })

    popover.present().then(() => Common.ensurePopoverOnScreen())

    popover.onDidDismiss().then(results => {
      this.lessonPrefs = this.preferencesProvider.getLessonPrefs()  // reload prefs since changed
    })
  }

  get isEditingNotes(): boolean {
    return this.notesBeingEdited !== null
  }

  notesBeingEdited: string = null

  editNotes() {
    this.notesBeingEdited = instanceToInstance(this.lesson.notes || '')
  }

  saveNotes() {
    if (this.isEditing) {
      this.lessonBeingEdited.notes = this.notesBeingEdited
    } else {
      const lesson = instanceToInstance(this.lesson)
      lesson.notes = this.notesBeingEdited
      this.teacherProvider.updateLesson(this.course, lesson)
    }

    this.notesBeingEdited = null
  }

  cancelNotes() {
    this.notesBeingEdited = null
  }

  get isOnline(): boolean {
    return navigator.onLine
  }

  // Rules checklist
  get isDefault(): boolean {
    const songs = (this.lessonBeingEdited || this.lesson).songs
    const count = songs.reduce((sum: number, song: LessonSong) => sum + (!song.isDefaultSong ? 1 : 0), 0)
    if (count === 2) {
      return songs[0].isHelloSong && songs[songs.length - 1].isGoodbyeSong
    } else {
      return false
    }
  }

  get isRhythmKids(): boolean {
    return this.course.classType === Course.ClassType.RhythmKidsLevel1 || this.course.classType === Course.ClassType.RhythmKidsLevel2 || this.course.classType == Course.ClassType.RhythmKids
  }

  get hasSwows(): boolean {
    return !this.isRhythmKids
  }

  get hasRhythmPatterns(): boolean {
    return this.course.classType !== Course.ClassType.RhythmKidsLevel2 && this.lesson.classType !== Course.ClassType.RhythmKidsLevel2
  }

  get hasPems(): boolean {
    return this.course.classType !== Course.ClassType.Babies
  }

  get pemName(): string {
    if (this.course.classType === Course.ClassType.InSchool) {
      return 'TEM'
    } else if (this.isRhythmKids) {
      return 'GEM';
    } else {
      return 'PEM'
    }
  }

  nondupleValidate(): LessonValidation {
    let target = 0
    if (this.isRhythmKids) {
      target = 1
    } else if (this.course.classType === Course.ClassType.InSchool) {
      target = 1
    } else if (this.course.classType === Course.ClassType.Generations) {
      target = 2
    }
    else {
      target = 3
    }

    if (this.isDefault) {
      return {isValid: false, textClass: 'default', iconClass: 'mt-empty', message: 'You need at least ' + target + ' non-duple'}
    }

    const count = (this.lessonBeingEdited || this.lesson).songs.reduce((sum: number, song: LessonSong) => sum + (song.isNonduple ? 1 : 0), 0)
    if (count >= target) {
      return {isValid: true, textClass: 'valid', iconClass: 'mt-check', message: 'You have at least ' + target + ' non-duple'}
    } else {
      return {isValid: false, textClass: 'invalid', iconClass: 'mt-alert', message: 'You need at least ' + (target - count) + ' more non-duple'
      }
    }
  }

  nonmajorValidate(): LessonValidation {
    let target = 0
    if (this.isRhythmKids) {
      target = 2
    } else if (this.course.classType === Course.ClassType.InSchool) {
      target = 1
    } else if (this.course.classType === Course.ClassType.Generations) {
      target = 2
    } else {
      target = 3
    }

    if (this.isDefault) {
      return {isValid: false, textClass: 'default', iconClass: 'mt-empty', message: 'You need at least ' + target + ' non-major'}
    }

    const count = (this.lessonBeingEdited || this.lesson).songs.reduce((sum: number, song: LessonSong) => sum + (song.isNonmajor ? 1 : 0), 0)
    if (count >= target) {
      return {isValid: true, textClass: 'valid', iconClass: 'mt-check', message: 'You have at least ' + target + ' non-major'}
    } else {
      return {isValid: false, textClass: 'invalid', iconClass: 'mt-alert', message: 'You need at least ' + (target - count) + ' more non-major'
      }
    }
  }

  swowValidate(): LessonValidation {
    let target = 0
    if (this.isRhythmKids) {
      target = 0
    } else if (this.course.classType === Course.ClassType.InSchool) {
      target = 1
    } else {
      target = 2
    }

    if (this.isDefault) {
      return {isValid: false, textClass: 'default', iconClass: 'mt-empty', message: 'You need at least ' + target + ' SWOWs'}
    }

    const count = (this.lessonBeingEdited || this.lesson).songs.reduce((sum: number, song: LessonSong) => sum + (song.isSwow ? 1 : 0), 0)
    if (count >= target) {
      return {isValid: true, textClass: 'valid', iconClass: 'mt-check', message: 'You have at least ' + target + ' SWOW'}
    } else {
      return {isValid: false, textClass: 'invalid', iconClass: 'mt-alert', message: 'You need at least ' + (target - count) + this.plural(' more SWOW', (target - count))
      }
    }
  }

  instrumentValidate(): LessonValidation {
    let target = 0
    if (this.isRhythmKids) {
      target = 1
    } else if (this.course.classType === Course.ClassType.InSchool) {
      target = 2
    } else {
      target = 3
    }

    if (this.isRhythmKids) {
      if (this.isDefault) {
        return {isValid: false, textClass: 'default', iconClass: 'mt-empty', message: 'You can use ' + target + ' instrument/props, in addition to drums'}
      }

      const count = (this.lessonBeingEdited || this.lesson).songs.reduce((sum: number, song: LessonSong) => sum + (song.hasInstrument ? 1 : 0), 0)
      if (count < target) {
        return {isValid: true, textClass: 'valid', iconClass: 'mt-check', message: 'You can use ' + target + ' instrument/props, in addition to drums'}
      } else if (count === target) {
        return {isValid: true, textClass: 'valid', iconClass: 'mt-check', message: 'You\'ve hit the maximum of using ' + target + ' instrument/prop, in addition to drums'}
      } else {
        return {isValid: false, textClass: 'invalid', iconClass: 'mt-alert', message: 'Oops! You have too many instrument/props, in addition to drums'}
      }
    }

    if (this.isDefault) {
      return {isValid: false, textClass: 'default', iconClass: 'mt-empty', message: 'You can use instrument/props up to ' + target + ' times'}
    }

    const count = (this.lessonBeingEdited || this.lesson).songs.reduce((sum: number, song: LessonSong) => sum + (song.hasInstrument ? 1 : 0), 0)
    if (count < target) {
      return {isValid: true, textClass: 'valid', iconClass: 'mt-check', message: 'You can use instrument/props up to ' + target + ' times'}
    } else if (count === target) {
      return {isValid: true, textClass: 'valid', iconClass: 'mt-check', message: 'You\'ve hit the maximum of using instrument/props ' + target + ' times'}
    } else {
      return {isValid: false, textClass: 'invalid', iconClass: 'mt-alert', message: 'Oops! You have too many instrument/props'}
    }
  }

  recordingValidate(): LessonValidation {
    let target = 0
    if (this.isRhythmKids) {
      target = 2
    } else if (this.course.classType === Course.ClassType.InSchool) {
      target = 2
    } else {
      target = 3
    }

    if (this.isDefault) {
      return {isValid: false, textClass: 'default', iconClass: 'mt-empty', message: 'You can use the recording up to ' + target + ' times'}
    }

    const count = (this.lessonBeingEdited || this.lesson).songs.reduce((sum: number, song: LessonSong) => sum + (song.useRecording ? 1 : 0), 0)
    if (count < target) {
      return {isValid: true, textClass: 'valid', iconClass: 'mt-check', message: 'You can use the recording up to ' + target + ' times'}
    } else if (count === target) {
      return {isValid: true, textClass: 'valid', iconClass: 'mt-check', message: 'You\'ve hit the maximum of using the recording ' + target + ' times'}
    } else {
      return {isValid: false, textClass: 'invalid', iconClass: 'mt-alert', message: 'Oops! You have too many recording uses'}
    }
  }

  tpValidate(): LessonValidation {
    let target = 0
    if (this.isRhythmKids) {
      target = 2
    } else if (this.course.classType === Course.ClassType.InSchool) {
      target = 1
    } else {
      target = 2
    }

    if (this.isDefault) {
      return {isValid: false, textClass: 'default', iconClass: 'mt-empty', message: 'You need ' + target + this.plural(' set', target) + ' of of tonal patterns'}
    }

    const count = (this.lessonBeingEdited || this.lesson).songs.reduce((sum: number, song: LessonSong) => sum + (song.hasTp ? 1 : 0), 0)
    if (count === target) {
      return {isValid: true, textClass: 'valid', iconClass: 'mt-check', message: 'You have ' + target + this.plural(' set', target) + ' of of tonal patterns'}
    } else if (count < target) {
      return {isValid: false, textClass: 'invalid', iconClass: 'mt-alert', message: 'You need ' + (target - count) + this.plural(' more set', target - count) + ' of tonal patterns'}
    } else {
      return {isValid: false, textClass: 'invalid', iconClass: 'mt-alert', message: 'Oops! You have too many tonal patterns'}
    }
  }

  rpValidate(): LessonValidation {

    // console.log('IN HERE')
    // console.log(this.course.classType)
    // this.lesson

    let target = 0
    if (this.lesson.classType === Course.ClassType.RhythmKidsLevel1) {
      target = 1
    } else if (this.lesson.classType === Course.ClassType.RhythmKidsLevel2) {
      target = 0
    } else if (this.course.classType === Course.ClassType.InSchool) {
      target = 1
    } else {
      target = 2
    }

    if (this.isDefault) {
      return {isValid: false, textClass: 'default', iconClass: 'mt-empty', message: 'You need ' + target + this.plural(' set', target) + ' of rhythm patterns'}
    }

    const count = (this.lessonBeingEdited || this.lesson).songs.reduce((sum: number, song: LessonSong) => sum + (song.hasRp ? 1 : 0), 0)
    if (count === target) {
      return {isValid: true, textClass: 'valid', iconClass: 'mt-check', message: 'You have ' + target + this.plural(' set', target) + ' of rhythm patterns'}
    } else if (count < target) {
      return {isValid: false, textClass: 'invalid', iconClass: 'mt-alert', message: 'You need ' + (target - count) + this.plural(' more set', target - count) + ' of rhythm patterns'}
    } else {
      return {isValid: false, textClass: 'invalid', iconClass: 'mt-alert', message: 'Oops! You have too many rhythm patterns'}
    }
  }

  pemValidate(): LessonValidation {
    let target = 0
    if (this.isRhythmKids) {
      target = 2
    } else if (this.course.classType === Course.ClassType.InSchool) {
      target = 1
    } else {
      target = 2
    }

    const count = (this.lessonBeingEdited || this.lesson).songs.reduce((sum: number, song: LessonSong) => sum + (song.hasPem ? 1 : 0), 0)

    if (this.isRhythmKids) {
      if (this.isDefault) {
        return {isValid: false, textClass: 'default', iconClass: 'mt-empty', message: `You can use up to 2 ${this.pemName}S (as needed)`}
      }

      if (count === 0) {
        return {isValid: false, textClass: 'invalid', iconClass: 'mt-alert', message: `You can use up to 2 ${this.pemName}S (as needed)`}
      } else if (count === 1) {
        return {isValid: true, textClass: 'valid', iconClass: 'mt-check', message: `You can use 1 more ${this.pemName} (as needed)`}
      } else if (count === 2) {
        return {isValid: true, textClass: 'valid', iconClass: 'mt-check', message: `You have 2 ${this.pemName}s`}
      } else {
        return {isValid: false, textClass: 'invalid', iconClass: 'mt-alert', message: `Oops! You have too many ${this.pemName}s`}
      }
    } else if (target === 2) {
      if (this.isDefault) {
        return {isValid: false, textClass: 'default', iconClass: 'mt-empty', message: `You need 1 or 2 ${this.pemName}s`}
      }

      if (count === 0) {
        return {isValid: false, textClass: 'invalid', iconClass: 'mt-alert', message: `You need 1 or 2 ${this.pemName}s`}
      } else if (count === 1) {
        return {isValid: true, textClass: 'valid', iconClass: 'mt-check', message: `You have 1 ${this.pemName}`}
      } else if (count === 2) {
        return {isValid: true, textClass: 'valid', iconClass: 'mt-check', message: `You have 2 ${this.pemName}s`}
      } else {
        return {isValid: false, textClass: 'invalid', iconClass: 'mt-alert', message: `Oops! You have too many ${this.pemName}s`}
      }
    } else {
      if (this.isDefault) {
        return {isValid: false, textClass: 'default', iconClass: 'mt-empty', message: `You need 1 ${this.pemName}`}
      }

      if (count === 0) {
        return {isValid: false, textClass: 'invalid', iconClass: 'mt-alert', message: `You need 1 ${this.pemName}`}
      } else if (count === 1) {
        return {isValid: true, textClass: 'valid', iconClass: 'mt-check', message: `You have 1 ${this.pemName}`}
      } else {
        return {isValid: false, textClass: 'invalid', iconClass: 'mt-alert', message: `Oops! You have too many ${this.pemName}s`}
      }
    }
  }

  // numSongsValidation(): LessonValidation {
  //   if (this.lesson.numSongs !== this.lesson.songs.length) {
  //     if (this.lesson.numSongs < this.lesson.songs.length) {
  //       return { isValid: false, textClass: 'invalid', iconClass: 'mt-alert', message: `You need ${this.lesson.songs.length - this.lesson.numSongs} less Activities` }
  //     } else {
  //       return { isValid: false, textClass: 'invalid', iconClass: 'mt-alert', message: `You need ${this.lesson.numSongs - this.lesson.songs.length} more Activities` }
  //     }
  //   } else {
  //     return { isValid: false, textClass: 'invalid', iconClass: 'mt-check', message: `${this.lesson.numSongs} Activities`}
  //   }
  // }

  private plural(value: string, count: number): string {
    if (count === 1) {
      return value
    }
    return value + 's'
  }

  percentValid() {
    const possible = 5 + (this.hasSwows ? 1 : 0) + (this.hasRhythmPatterns ? 1 : 0) + (this.hasPems ? 1 : 0)
    const count = ((this.nondupleValidate().isValid ? 1 : 0) +
    (this.nonmajorValidate().isValid ? 1 : 0) +
    (this.hasSwows ? (this.swowValidate().isValid ? 1 : 0) : 0) +
    (this.instrumentValidate().isValid ? 1 : 0) +
    (this.recordingValidate().isValid ? 1 : 0) +
    (this.tpValidate().isValid ? 1 : 0) +
    (this.hasRhythmPatterns ? (this.rpValidate().isValid ? 1 : 0) : 0) +
    (this.hasPems ? (this.pemValidate().isValid ? 1 : 0) : 0))
    return Math.round(count / possible * 100)
  }

  svgProgress() {
    return `${this.percentValid()} 100`
  }

  unmetRules(): string {
    let unmetRules = ''
    unmetRules += this.nondupleValidate().isValid ? '' : ('• ' + this.nondupleValidate().message + '\n')
    unmetRules += this.nonmajorValidate().isValid ? '' : ('• ' + this.nonmajorValidate().message + '\n')
    if (this.hasSwows) {
      unmetRules += this.swowValidate().isValid ? '' : ('• ' + this.swowValidate().message + '\n')
    }
    unmetRules += this.instrumentValidate().isValid ? '' : ('• ' + this.instrumentValidate().message + '\n')
    unmetRules += this.recordingValidate().isValid ? '' : ('• ' + this.recordingValidate().message + '\n')
    unmetRules += this.tpValidate().isValid ? '' : ('• ' + this.tpValidate().message + '\n')
    if (this.hasRhythmPatterns) {
      unmetRules += this.rpValidate().isValid ? '' : ('• ' + this.rpValidate().message + '\n')
    }
    if (this.hasPems) {
      unmetRules += this.pemValidate().isValid ? '' : ('• ' + this.pemValidate().message + '\n')
    }
    // unmetRules += this.numSongsValidation().isValid ? '' : ('• ' + this.numSongsValidation().message + '\n')
    return unmetRules.replace(new RegExp('You need a', 'g'), 'A').replace(new RegExp('You need ', 'g'), '')
  }

  closeMenu() {
    this.addSongShown = false
    this.songDetailShown = false
    this.addPemShown = false
    this.pemDetailShown = false
    this.toggleMenu('close')
    this.audioProvider.stop()
  }

  scrollLeft: number = 0
  onScroll(event: Event) {
    this.scrollLeft = event.target['scrollLeft']
  }

  trackBySongUuid(index: number, lessonSong: LessonSong): string {
    return lessonSong.uuid
  }

  getPDFTitle(includeLesson: boolean = true): string{
    if (!this.course || !this.lesson) {
      return ''
    }
    let title = this.resources.findCollection(this.course.collectionUuid).name
    if (includeLesson) {
      title += ` - ${this.lesson.name}`
    }
    return title
  }

  getPDFLessonName(): string {
    if (!this.course || !this.lesson) {
      return ''
    }
    return this.lesson.name
  }
}

export class LessonValidation {
  isValid: boolean
  textClass: string
  iconClass: string
  message: string
}
